export class BaseModel {

}


// WEBPACK FOOTER //
// ./src/app/models/base/base.model.ts